import React from "react";
import { useTranslation } from "react-i18next";

const BadgeInactiveButtons = () => {
  const { t } = useTranslation();

  return (
    <>
      <button
        className="w-full mt-3 text-lg rounded-lg rounded-tr-none px-6 bg-gray-400 text-white uppercase"
        disabled={true}
      >
        {t("download")}
      </button>
      <button
        className="w-full mt-3 text-lg rounded-lg rounded-tr-none px-6 bg-gray-400 text-white uppercase"
        disabled={true}
      >
        {t("share")}
      </button>
    </>
  );
};

export default BadgeInactiveButtons;
